// extracted by css-extract-rspack-plugin
export default {"root":"sNUlCZjo60rccvRY","content":"K8Z_WoZ6SSkp_Bjl","composedContent":"lWIVcQNMM0gVuNNm","trailingItemEnd":"t3fuy3DxgLQE8s1I"};